import React from "react";
import ReactDOM from "react-dom";
import '@xanadu_ai/xanadu-component-library/dist/index.css'
import "./index.css";
import App from "./App"; // default CRA app, could be a 404 page or something to show if there are errors
import reportWebVitals from "./reportWebVitals";
import {
  defaultKcProps,
} from "keycloakify";
import { kcContext } from "./KcApp/kcContext";
import { KcApp } from "./KcApp";
// import BackgroundSlider from "./KcApp/Components/BackgroundSlider/BackgroundSlider";
import backgroundImage from "./KcApp/Components/BackgroundSlider/images/background.png"

ReactDOM.render(
  <React.StrictMode>
    {/* <BackgroundSlider /> */}
    <div
      className="background-image"
      style={{ backgroundImage: `url("${backgroundImage}")` }}>
    </div>
    {kcContext !== undefined ? (
      <KcApp
        kcContext={kcContext}
        {...{
          ...defaultKcProps,
        }}
      />
    ) : (
      <App />
    )}
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
